import { Component, inject, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastService } from '../utils/toast.service';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './components/toast/toast.component';
import { ModalService } from '../utils/modal.service';
import { ModalComponent } from "./components/modal/modal.component";
import { InactivityService } from 'src/utils/inactivity.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToastComponent, ModalComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private readonly inactivity = inject(InactivityService);
  public toastService = inject(ToastService);
  public modalService = inject(ModalService);

  ngOnInit(): void {
    this.inactivity.init();
  }

}